(function () {
	'use strict';

	angular
		.module('wizard-future7.directives')
		.directive('particles', Particles)

	/** @ngInject */
	function Particles(PATHS) {
		function ParticlesController() {
			particlesJS.load('particles-bg', 'app/dist/uploads/particles.json');
		}

		return {
			bindToController: true,
			controller: ParticlesController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/particles/particles.html`,
			scope: {}
		}
	}
}());